





























































































import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { simpleDate } from "@/lib/utility/date-helper";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { ISharedContent } from "@/models/shared-content.entity";

@Component({ components: { Tooltip } })
class RefsSharedContent extends BaseRef<ISharedContent> implements IRefDetail<ISharedContent> {
  readonly RefTypeMap = RefTypeMap;
  readonly simpleDate = simpleDate;

  @Prop() item!: ISharedContent;
  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) confirmable!: boolean;
  @Prop({ default: false }) isConfirmable!: boolean;

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  goToDetail() {
    this.item.goTo(this.$router).detail();
  }

  copyLinkToClipboard() {
    this.item.copyLinkToClipboard();
  }

  getUserNameForId(id: string) {
    const user = PartnerUserModule.maps.id.get(id)[0];

    let name = "";
    if (user) {
      name = `${user.firstName} ${user.lastName}`;
    }

    return name;
  }
}

export default RefsSharedContent;
